const NOTIFICATIONS = {
	UPDATE_BTN: "Atualizar",
	ADD_MEMBER: "Adição de alunos",
	STATUS: "Status:",
	WORKING: "Em andamento",
	FINISHED: "Finalizado",
	ADDED_STUDENTS: "Alunos adicionados:",
	FAILED_STUDENTS: "Alunos não adicionados:",
	ERROR_TIP: "Ocorreu um erro ao adicionar os alunos listados acima. Tente novamente ou verifique se eles já estão na turma antes de adicionar.",
	NOTHING_TO_SHOW: "Nada para mostrar",
	NEW: "Novo",
	LAST_UPDATE: "Última atualização: "
};

export default NOTIFICATIONS;